import { getColorTheme } from './color';
import { defaultColorScheme, colors, size } from '../constants';
export const createTheme = (osColorScheme) => {
    const colorScheme = osColorScheme !== null && osColorScheme !== void 0 ? osColorScheme : defaultColorScheme;
    return {
        colorScheme,
        color: getColorTheme(colorScheme, colors),
        size
    };
};
//# sourceMappingURL=theme.js.map